export const GET_ASSORTMENT_PRODUCTS = `ASSORTMENTS:GET_ASSORTMENT_PRODUCTS`;
export const GET_ASSORTMENT_PRODUCTS_SUCCESS = `ASSORTMENTS:GET_ASSORTMENT_PRODUCTS_SUCCESS`;
export const GET_ASSORTMENT_PRODUCTS_ERROR = `ASSORTMENTS:GET_ASSORTMENT_PRODUCTS_ERROR`;
